import { estimateStrength } from "./strength.js";

export const MIN_MASTER_LENGTH = 12;

/** Field hint for a new master password under the given minimum. */
export function masterPasswordHint(minLength: number): string {
  return `Mindestens ${minLength} Zeichen. Eine Passphrase ist ideal.`;
}

/**
 * Rules for a new master password. Returns a German message, or undefined when the password is fine.
 * minLength comes from the admin policy and never goes below the built-in minimum.
 */
export function masterPasswordProblem(
  password: string,
  confirm: string,
  avoid?: string | undefined,
  minLength: number = MIN_MASTER_LENGTH
): string | undefined {
  const required = Math.max(minLength, MIN_MASTER_LENGTH);
  if (password.length < required) {
    return `Das Master-Passwort braucht mindestens ${required} Zeichen.`;
  }
  if (estimateStrength(password).level < 2) {
    return "Wähle ein stärkeres Master-Passwort. Eine Passphrase aus mehreren Wörtern hilft.";
  }
  if (avoid !== undefined && password === avoid) {
    return "Das neue Master-Passwort muss sich vom bisherigen unterscheiden.";
  }
  if (password !== confirm) {
    return "Die beiden Passwörter stimmen nicht überein.";
  }
  return undefined;
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim().toLowerCase());
}
